import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { HeaderStyles } from '~src/spacesPlatform/components/header/HeaderStyles';

import { cssClass } from '../../style';

const cssPrefix = 'NotificationCenter';

export namespace NotificationCenterStyles {

  export const panelWidth = 380;
  export const panelMaxHeight = 600;
  export const titleFontSize = TabStyles.Typography.Sizing.XLarge;
  export const subtitleFontSize = 14;
  export const commonSpace = 16;

  export const notificationContainerStyle: React.CSSProperties = {
    ...HeaderStyles.MenuPanelStyle,
    width: panelWidth,
    height: 'inherit',
    maxHeight: panelMaxHeight,
    overflow: 'hidden',
    padding: 0
  };

  export const notificationPanelHeaderContainer = cssClass(cssPrefix, 'panel-header', {
    background: 'rgb(241,241,241)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '22px',
    padding: '5px',
    $nest: {
      'a': {
        display: 'inline-block',
        marginLeft: '10px'
      }
    }
  });

  export const notificationMarkAllReadButton: React.CSSProperties = {
    textDecoration: 'underline'
  };

  export const notificationMarkAllReadLinkDisabled: React.CSSProperties = {
    verticalAlign: 'super',
    textDecoration: 'underline'
  };

  export const notificationPanelTab = cssClass(cssPrefix, 'panel-tab', {
    $nest: {
      '[role="tablist"]': {
        borderBottom: `1px solid ${CommonStyles.Colors.Grey178}`
      },
      '[role="tab"]': {
        borderBottomWidth: 0
      }
    }
  });

  export const notificationTabContent: React.CSSProperties = {
    minHeight: '200px',
    maxHeight: '535px',
    overflowY: 'auto'
  };

  export const notificationEmptyList: React.CSSProperties = {
    textAlign: 'center',
    padding: '20px 0 20px 0',
  };

  export const notificationEmptyTitle: React.CSSProperties = {
    fontSize: titleFontSize,
    marginTop: '25px'
  };

  export const notificationSecondTitle: React.CSSProperties = {
    fontSize: titleFontSize,
    marginTop: commonSpace
  };

  export const notificationEmptySubtitle: React.CSSProperties = {
    fontSize: subtitleFontSize,
    marginTop: '25px'
  };

  export const userPreferenceLink = cssClass(cssPrefix, 'user-preference', {
    padding: '2px 2px 0 2px',
    outline: `1px solid transparent`,
    border: `1px solid transparent`,
    verticalAlign: 'bottom',
    $nest: {
      '&:focus': {
        outline: `1px solid ${CommonStyles.Colors.FocusBorderBlue}`,
        border: `1px solid transparent`,
        boxShadow: `0 0 4px 0 ${CommonStyles.Colors.FocusBorderBlue}`
      },
    }
  });
}
